<template>
    <div class="ticket-detail">
        <v-container fluid>
            <v-row class="mx-5 my-10" justify="center">
                <v-card max-width="1000">
                    <v-list-item three-line>
                        <v-list-item-content>
                            <div class="overline mb-4">TICKET</div>
                            <v-list-item-title v-if = "ticket_data" class="headline">{{ticket_data.subject}}</v-list-item-title>
                            <v-list-item-subtitle v-if = "ticket_id" class="mb-3">{{ticket_id}}</v-list-item-subtitle>
                            <!-- <v-list-item-subtitle v-if = "ticket_data">{{ticket_data.description}}</v-list-item-subtitle> -->
                            <div v-if = "ticket_data">{{ticket_data.description}}</div>
                        </v-list-item-content>
                    </v-list-item>
                    <v-expansion-panels focusable>
                        <v-expansion-panel
                        v-for=" (conversation,index) in conversations"
                        :key="conversation.id"
                        >
                        <v-expansion-panel-header>ノート {{index+1}}</v-expansion-panel-header>
                        <v-expansion-panel-content>
                            {{conversation.body_text}}
                        </v-expansion-panel-content>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </v-card>
            </v-row>
            <!-- Researcher Part -->
            <researcherDraft v-if="ticket_data" :ticket-data="ticket_data"></researcherDraft>
            <!-- Comment Area -->
            <commentCard v-if="ticket_data" :update-key="updateKey" :ticket-id="ticket_id" v-on:send-new-comment="updateKey=$event" :key="updateKey"></commentCard>
            <!-- Concierge Part -->
            <v-divider class="primary"></v-divider>
            <v-row justify="center" align-content-center>
                <v-col align-self="center" class="mt-2">
                    <h4>コンシェルジュを選択: </h4>
                </v-col>
                <v-col cols="12">
                        <v-select
                        v-model="editor"
                        :items="editors"
                        label="Concierges"
                        outlined
                        hide-details
                        clearable
                        ></v-select>
                </v-col>
                <v-col cols="12">
                        <v-select
                        v-model="second_editor"
                        :items="editors"
                        label="Second Concierges"
                        outlined
                        hide-details
                        clearable
                        ></v-select>
                </v-col>
            </v-row>
            <v-row justify="center" class="my-5 info--text">
                <h1 class="headline">Report</h1>
            </v-row>
            <v-row>
                <v-col>
                     <Vue2Editor :editor="editor" :second_editor="second_editor"></Vue2Editor>
                </v-col>
            </v-row>
            <v-divider class="primary"></v-divider>
            <!-- <EditCard class="my-5"></EditCard> -->
            <!-- <v-row class="ml-1 mt-5">
                <v-btn depressed>Add a New Card</v-btn>
            </v-row>
            <v-row justify="center" class="mt-3">
                <v-col cols="12" v-for="card in cards" :key="card.name">
                    <v-row justify="center">
                        <v-card max-width="1200">
                            <v-container fluid>
                                <v-row no-gutters class="align-center">
                                    <v-col cols="auto" class="mr-2 yellow">
                                        <v-img
                                            max-height="300"
                                            max-width="300"
                                            min-height="180"
                                            :src="card.img_url"
                                            class="hidden-sm-and-down"
                                        ></v-img>
                                    </v-col>
                                    <v-col>
                                        <v-card-title class="subtitle-1 mb-5">
                                            {{card.name}}
                                        </v-card-title>
                                        <v-card-subtitle class="body-2 font-weight-light">
                                            <p>{{card.comment}}</p>
                                        </v-card-subtitle>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card>
                    </v-row>
                </v-col>
            </v-row>  -->
            <v-divider class="primary"></v-divider>
            <v-row justify="center" class="mt-5">
                <v-btn @click="createReport(content)" class="primary info--text">Create Report</v-btn>
            </v-row>
        </v-container>
    </div>
</template>

<script>
/* eslint-disable no-console */
import {db} from '@/fb'
// import {VueEditor} from 'vue2-editor'
import axios from 'axios'
import freshConfig from '@/freshconfig'
// import EditCard from '@/components/dialogs/EditCard'
import Vue2Editor from '@/components/editor/Vue2Editor'
import researcherDraft from '@/components/tickets/researcherDraft'
import commentCard from '@/components/editor/commentCard'

export default {
    name:'TicketDetail',
    components:{Vue2Editor,researcherDraft,commentCard},
    data(){
        return {
            conversations: [],

            editor:'',
            second_editor:"",
            editors:[],

            ticket_id:null,
            ticket_data:null,
            ticketUID:null,

            content:"<h1>Some initial content</h1>",

            updateKey:0,

            paidForTicket:false,
            internalTicket:null,
        }
    },
    created(){
        let ref = db.collection('reports')
            ref.doc(String(this.$route.params.id)).get()
            .then(doc=>{
                this.editor = doc.data().editor
                this.second_editor = doc.data().second_editor
                this.ticket_id = doc.data().id
                this.ticket_data = doc.data()
            })
            .catch(err=>{
                console.log("created error")
                console.log(err)
            })

        let ref2 = db.collection('users')
        ref2.get()
        .then(snap=>{
            snap.forEach(doc=>{
                this.editors.push(doc.data().email)
            })
        })

        let refPaid = db.collection('ticket_completed').doc(String(this.$route.params.ticket_id))
        refPaid.get().then(doc=>{
            if(doc.exists){
                this.paidForTicket = doc.data().pay_for_ticket
                this.internalTicket = false
            }else{
                this.internalTicket = true
            }
        })
    },
    async mounted(){
        try{
            const API_KEY = freshConfig.api_key;
            const FD_ENDPOINT = "tpoconcierge";
            var PATH = '/api/v2/tickets/';
            const URL =  "https://" + FD_ENDPOINT + ".freshdesk.com"+ PATH + String(this.$route.params.ticket_id) +  "?include=conversations";
            const res = await axios({
                    method: 'get',
                    url: URL,
                    auth: {
                        username:API_KEY,
                        password:'X'
                    }
                });
            this.conversations = res.data.conversations
        }catch(err){
            console.log("mounted error")
            console.log(err)
        }
    },
    methods:{
        // save2firestore(){
        //     let ref = db.collection('reports').doc(String(this.$route.params.id));
        //     if(this.second_editor==null){
        //     ref.set({
        //         report_comment: this.content,
        //         editor: this.editor,
        //         second_editor:"",
        //     },{ merge: true })
        //     .then(()=>{
        //         this.feedback = "保存しました。"
        //         this.snackbar = true
        //     })
        //     .catch(err=>{
        //         this.feedback = "エラー：保存できませんでした。容量を1MB以下にしてください、またはインターネット接続を確認してください。"
        //         this.snackbar = true
        //         /* eslint-disable no-console */
        //         console.log(err)
        //         /* eslint-enable no-console */
        //     })}else{
        //         ref.set({
        //             report_comment: this.content,
        //             editor: this.editor,
        //             second_editor: this.second_editor,
        //         },{ merge: true })
        //         .then(()=>{
        //             this.feedback = "保存しました。"
        //             this.snackbar = true
        //         })
        //         .catch(err=>{
        //             this.feedback = "エラー：保存できませんでした。容量を1MB以下にしてください、またはインターネット接続を確認してください。"
        //             this.snackbar = true
        //             /* eslint-disable no-console */
        //             console.log(err)
        //             /* eslint-enable no-console */
        //         })
        //     }
        // },
        createReport(){
            if(this.internalTicket){
                this.$router.push({name:'TicketReport', params:{id:String(this.$route.params.id)}})
            }else{
                if(this.paidForTicket){
                    this.$router.push({name:'TicketReport', params:{id:String(this.$route.params.id)}})
                }else{
                    alert('ドラフトレポートを認めてから、レポートを作成しましょう！')
                }
            }
        }
    }
}
</script>

<style>
    p {
    font-size: 16px !important;
    }
</style>